import axios from 'axios'
import { encrypt, getAnomaliesCheck, getMode, getToken } from '../functions/globalFunctions'
import swal from 'sweetalert'

// Server urls
export const url = `https://backend.hankerbusiness.com`
export const siteUrl = `https://dashboard.hankerbusiness.com`
export const utilUrl = `https://utils-server.hankerbusiness.com`
// export const url = `http://54.176.206.1:8080`
// export const siteUrl = `http://54.176.206.1:3003`
// export const utilUrl = `http://54.176.206.1:5000`
// testing Server urls

// export const url = `http://54.241.201.130:8080`
// export const siteUrl = `http://54.241.201.130:3003`
// export const utilUrl = `http://54.241.201.130:5000`

// local urls
// export const url = `http://localhost:8080`
// export const siteUrl = `http://localhost:3003`
// export const utilUrl = `https://utils-server.hankerbusiness.com`
// export const utilUrl = `http://localhost:5000`

// export const url = `http://192.168.100.19:8080`
// export const siteUrl = `http://localhost:3003`
// export const utilUrl = `http://localhost:5000`

export const connection_string = `${url}`

const jwt = getToken()
const added_data_axios = {
  mode: getMode(),
  anomaliesCheck: getAnomaliesCheck() == 'true' ? true : false,
}

export const publicAPI = axios.create({
  baseURL: connection_string,
  data: { mode: getMode(), anomaliesCheck: getAnomaliesCheck() },
})

export const privateAPI = axios.create({
  baseURL: connection_string,
  transformRequest: [
    (body = {}) => {
      const { data } = body
      return { data: encrypt({ ...added_data_axios, ...data }) }
    },
    ...axios.defaults.transformRequest,
  ],
  headers: {
    common: { Authorization: `Bearer ${jwt}` },
  },
})

privateAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('🚀 ~ file: constants.js:45 ~ error:', error)
    if ((error.response && error.response.status === 500) || error.code === 'ERR_NETWORK') {
      swal({
        title: 'Server Error Please Try Again',
        icon: 'error',
        buttons: 'OK',
      })
      // .then(() => window.location.reload())
    }
    if (error.response && error.response.status === 400) {
      console.log('🚀 ~ file: constants.js:54 ~ error.response:', error.response)
      swal({
        title: error.response.data.message,
        icon: 'error',
        buttons: 'OK',
      })
    }
    // return Promise.reject(error)
  },
)

export const privateAPIFormData = axios.create({
  baseURL: connection_string,
  headers: { common: { Authorization: `Bearer ${jwt}` } },
})
